import { createFileRoute } from "@tanstack/react-router";
import { CampaignDesignServicePage } from "./services_.campaign-design";

export const Route = createFileRoute("/services_/branding-creatives-and-campaign-design-services")({
  head: () => ({
    meta: [
      {
        title: "Campaign Design Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "360-Degree Integrated Campaign Design.",
      },
    ],
  }),
  component: CampaignDesignServicePage,
});
